<div class="modal-header modal-h">
    <h5 class="modal-title" id="addAddressLabel">Adauga card</h5>
    <button type="button" class="btn-close" (click)="closeBtnClick()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-b">
    <form [formGroup]="addCardForm" (ngSubmit)="addCard()">
        <div class="form-group">
            <label for="cardNumber" class="">Numar Card</label>
            <div class="position-relative">
                <input type="text" class="form-control" formControlName="" id="cardNumber" placeholder="XXXX XXXX XXXX XXXX">
                <span class="ficon icon-credit-card feather"></span>
                <div *ngIf="addCardForm.controls.cardNumber?.touched &&
           addCardForm.controls.cardNumber?.errors?.required"
                     class="invalid-feedback">
                    Card Number is required
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="name" class="">Nume</label>
            <div>
                <input type="text" class="form-control" formControlName="name" id="name" placeholder="Numele inscriptionat pe card">
                <div *ngIf="addCardForm.controls.name?.touched &&
           addCardForm.controls.name?.errors?.required"
                     class="invalid-feedback">
                    Name is required
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="expiredDate" class="">Data expirarii</label>
            <div>
                <input type="text" class="form-control" formControlName="name" id="expiredDate">
                <div *ngIf="addCardForm.controls.expiredDate?.touched &&
           addCardForm.controls.expiredDate?.errors?.required"
                     class="invalid-feedback">
                    Expiration date is required
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="securityCode" class="">Cod securitate</label>
            <div>
                <input type="text" class="form-control securityCode" formControlName="name" id="securityCode">
                <div *ngIf="addCardForm.controls.securityCode?.touched &&
           addCardForm.controls.securityCode?.errors?.required"
                     class="invalid-feedback">
                    Security Code is required
                </div>
            </div>
        </div>

        <div class="modal-f space-between">
            <button type="submit" class="btn btn-primary" [disabled]="addCardForm.invalid">Salveaza</button>
            <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">Anuleaza</button>
        </div>
    </form>
</div>
